import { Injectable } from '@angular/core';
import { ITicketType } from 'src/app/models/ticket.model';
import { Provider } from '../provider';

@Injectable()
export class TicketTypeService extends Provider<ITicketType> {
  protected url = 'events/ticket-types';
}
